export default {
  "content": "<path d=\"M13.5 15h-5v-2h5v2zM15.5 10h-8V8h8v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 2.5a1.001 1.001 0 01.956 1.294c-.927 3.011-.59 5.313-.157 7.85.436 2.556.974 5.356.18 9.066a1 1 0 01-.98.79H5a1 1 0 01-.977-1.21c.705-3.29.244-5.74-.195-8.31-.442-2.586-.856-5.286.218-8.774A1 1 0 015 2.5h14zm-13.24 2c-.675 2.673-.36 4.808.038 7.145.388 2.27.854 4.733.396 7.855h11.977c.48-2.901.059-5.16-.344-7.52-.386-2.258-.75-4.6-.122-7.48H5.76z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};